import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Crown, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setStatus("error"); return; }
    const poll = async () => {
      tries.current += 1;
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") { await refresh(); setStatus("success"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch {}
      if (tries.current > 12) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [refresh]);

  return (
    <div className="max-w-lg mx-auto px-6 py-20 text-center">
      {status === "checking" && (<><Loader2 className="w-12 h-12 text-neon-pink animate-spin mx-auto mb-4" /><h1 className="font-head text-2xl font-bold">Confirming your payment...</h1><p className="text-muted-foreground mt-2">This only takes a moment.</p></>)}
      {status === "success" && (
        <div className="fade-up">
          <div className="w-20 h-20 rounded-full bg-neon-pink/20 flex items-center justify-center mx-auto mb-6 glow-pink"><Crown className="w-10 h-10 text-neon-pink" /></div>
          <h1 className="font-head text-3xl font-black">Welcome to Premium!</h1>
          <p className="text-muted-foreground mt-3">You now have unlimited recordings and the full professional studio.</p>
          <div className="flex gap-3 justify-center mt-8">
            <Button onClick={() => nav("/record")} className="rounded-full bg-neon-pink hover:bg-neon-pink/90 glow-pink font-bold px-8">Start Singing</Button>
            <Button onClick={() => nav("/billing")} variant="outline" className="rounded-full glass border-white/20">View Billing</Button>
          </div>
        </div>
      )}
      {(status === "error" || status === "timeout") && (<><h1 className="font-head text-2xl font-bold">Payment not confirmed</h1><p className="text-muted-foreground mt-2">{status === "timeout" ? "It's taking longer than expected. Check your billing page shortly." : "We couldn't confirm your payment."}</p><Button onClick={() => nav("/premium")} className="rounded-full bg-neon-pink mt-6">Back to Premium</Button></>)}
    </div>
  );
}
